import CollectorCards from "@/components/CollectorCards";
import { UserProfile } from "@auth0/nextjs-auth0/client";
import { Button, Center, Container, Link, Spinner } from "@chakra-ui/react";
import { useWallet } from "@solana/wallet-adapter-react";
import { useEffect, useState } from "react";

export default function AccountLogic(props: { user: UserProfile | undefined }) {
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const wallet = useWallet();

  useEffect(() => {
    if (props.user) {
      setIsLoading(true);
      fetchUserData();
    }
  }, [wallet]);

  async function fetchUserData() {
    if (props.user) {
      try {
        const response = await fetch(`/api/protected`);
        const data = await response.json();
        setUserData(data.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    }
  }

  if (isLoading) {
    return (
      <>
        <Center>
          <Spinner size="xl" />
        </Center>
      </>
    );
  }

  if (!props.user) {
    return <></>;
  }

  return (
    <>
      {props.user && (
        <>
          <Container mt={10} mb={10} maxW={500}></Container>
          <Container>
            <CollectorCards userData={userData} />
          </Container>
          <Center mb={100} mt={10}>
            <Button size="sm" border="1px" borderColor="gray">
              <Link href="/api/auth/logout">Logout</Link>
            </Button>
          </Center>
        </>
      )}
    </>
  );
}
